import { render, staticRenderFns } from "./PlaceDetailsModal.vue?vue&type=template&id=4ba101f1&"
import script from "./PlaceDetailsModal.vue?vue&type=script&lang=ts&"
export * from "./PlaceDetailsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports